import MedicoOnline from './MedicoOnline';

export default MedicoOnline